import { defineComponent as t, createBlock as n, openBlock as l, unref as a, mergeProps as c, withCtx as p, createElementVNode as i } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconHeartBroken",
  __name: "IconHeartBroken",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const r = o;
    return (d, e) => (l(), n(a(m), c(r, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        i("path", {
          "fill-rule": "evenodd",
          d: "M7.5 4.87a3.75 3.75 0 0 0-3.75 3.75c0 1.14.596 2.126 1.462 2.977l.014.014L12 19.01l6.774-7.4.014-.013c.866-.85 1.462-1.838 1.462-2.977a3.75 3.75 0 0 0-3.75-3.75c-.712 0-1.344.258-1.91.627a.75.75 0 0 1-.82-1.257c.722-.47 1.637-.87 2.729-.87 2.9 0 5.25 2.35 5.25 5.25 0 1.694-.888 3.038-1.896 4.033l-6.932 7.57a1.25 1.25 0 0 1-1.844 0l-6.932-7.57C3.138 11.658 2.25 10.313 2.25 8.62c0-2.9 2.35-5.25 5.25-5.25 1.204 0 2.275.487 3.09 1.016a9.52 9.52 0 0 1 1.75 1.485 1.216 1.216 0 0 1 .187 1.372l-1.474 2.948L13 9.412c1.068-.427 2.097.692 1.583 1.72l-1.912 3.824a.75.75 0 1 1-1.342-.671l1.618-3.236L11 11.83c-1.068.426-2.097-.692-1.583-1.72L11.1 6.743a7.965 7.965 0 0 0-1.328-1.1C9.089 5.2 8.304 4.87 7.5 4.87",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
